export enum ClassType {
  'item' = 'item',
  'service' = 'service',
}
